import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcCard } from '@one/react';

export type PocCardProps = ComponentPropsWithoutRef<typeof OwcCard>;

export const PocCard = forwardRef<ElementRef<typeof OwcCard>, PocCardProps>((props, ref) => (
    <OwcCard ref={ref} {...props} />
));

PocCard.displayName = 'PocCard';
